import React, { useState } from 'react';
import { DeviceHelper, FormatHelper, generateId } from '@adp-wfn/mdf-core';
import { Placement2 } from './Overlay2';
import { OverlayTrigger2, TriggerType } from './OverlayTrigger2';
import { Popover2 } from './Popover2';
import { resolveAriaProperty } from '@synerg/vdl-react-components';
import { MDFContentPane } from './MDFContentPane';
import { MDFButton2 } from './MDFButton2';
import { MDFIcon } from './MDFIcon';
import { SdfIcon } from '@waypoint/react-components';
import QuestionCircle from 'adp-react-icons/lib/fa/question-circle';

export interface IMDFLegacyHelpIconProps {
  containerClassName?: string;
  helpMessage: string;
  iconClassName?: string;
  id?: string;
  placement?: Placement2;
  tabIndex?: number;
  trigger?: TriggerType[];
  ariaLabel?: any;
  'aria-label'?: string;
  altText?: string;
}

export const MDFLegacyHelpIcon = (props: IMDFLegacyHelpIconProps) => {
  const { altText, containerClassName, trigger, placement, helpMessage, iconClassName, tabIndex } = props;
  const [show, setShow] = useState(false);
  const [id] = useState(props.id || generateId('MDFLegacyHelpIcon'));
  const isMobile = DeviceHelper.isMobileDevice();

  let Icon = iconClassName ? <MDFIcon altText={altText || 'Help'} className={iconClassName} /> : <QuestionCircle />;

  // In a OneUX context, use the OneUX action-help icon.
  if ((window['SynergConfig']?.theme === 'one') && !iconClassName) {
    Icon = <SdfIcon icon="action-help" />;
  }

  const ariaLabel = resolveAriaProperty(MDFLegacyHelpIcon.displayName, 'aria-label', 'ariaLabel', props);
  const [isAriaOwns, updateAriaOwns] = useState(false);

  const updateOnToggle = (newShow) => {
    if (newShow) {
      updateAriaOwns(true);
      setShow(true);
    }
    else {
      updateAriaOwns(false);
      setShow(false);
    }
  };

  // Aria owns is needed to read the content of the popup and is required to add only when the Button is clicked.
  // hover state is not required for SR testing.
  return (
    <span className="mdf-simple-help-icon-container" {...isAriaOwns && { 'aria-owns': id }}>
      <OverlayTrigger2
        flip={true}
        placement={placement}
        show={show}
        trigger={isMobile ? ['click'] : (trigger || ['click', 'hover'])}
        onToggle={updateOnToggle}
        overlay={
          <Popover2 id={id} className={`mdf-popover-maxWidth ${containerClassName || ''}`}>
            <MDFContentPane html={helpMessage} />
          </Popover2>
        }
      >
        <MDFButton2 variant={'text'} aria-label={(ariaLabel || FormatHelper.formatMessage('@@HelpInformation'))} buttonStyle={'link'} tabIndex={tabIndex || 0}>
          {Icon}
        </MDFButton2>
      </OverlayTrigger2>
    </span>
  );
};

MDFLegacyHelpIcon.displayName = 'MDFLegacyHelpIcon';
